import React from "react";
import logo from "../../../assets/logo.png";

export function HeaderLogo() {
    return (
        <img src={logo} alt="Logo" className={"global_header__logo"}/>
    );
}
